import { LayoutLoading } from 'components/LayoutLoading'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getAdminConfig, setAdminConfig } from 'services'
import { Button, InputFile } from 'stories/components'

interface EmailBannerUploaderProps {}

export const EmailBannerUploader: React.FC<EmailBannerUploaderProps> = ({}) => {
  const [file, setFile] = useState<any>()
  const [isLoading, setLoading] = useState(true)
  const [broadcastUrl, setBroadcastUrl] = useState('')

  useEffect(() => {
    getAdminConfig('emailBanner')
      .then(({ broadcastUrl }) => setBroadcastUrl(broadcastUrl))
      .finally(() => setLoading(false))
  }, [])

  const onUploadImage = () => {
    if (!file) return

    const formData = new FormData()
    formData.append('type', 'broadcast')
    formData.append('file', file)

    setLoading(true)
    setAdminConfig('emailBanner', formData)
      .then(({ broadcastUrl }) => {
        setBroadcastUrl(broadcastUrl)
        toast('Email banner has been saved successfully.', { type: 'info' })
      })
      .finally(() => setLoading(false))
  }

  return (
    <div className="shadow1 p-4 rounded mb-6 relative">
      <LayoutLoading show={isLoading} />
      <div className="border-b font-bold mb-4">Upload Email Banner</div>
      <div>
        <div className="grid md:grid-cols-2">
          <div className="input-file input">
            <InputFile
              multiple={false}
              onChange={setFile}
              title="Email Banner"
              acceptFileTypes="image/*"
              value={file}
              name="email-banner"
            />
          </div>
          <div className="mt-4">
            <p className="text-sm">Banner image</p>
            {broadcastUrl && <img src={broadcastUrl} className="w-full" />}
          </div>
        </div>
        <div className="flex justify-start mt-4">
          <Button disabled={!file} loading={isLoading} onClick={onUploadImage}>
            Submit
          </Button>
        </div>
      </div>
    </div>
  )
}
